﻿import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { GMetrixDropdown } from 'components/GMetrixDropdown/GMetrixDropdown';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { Card, Col, Container } from 'react-bootstrap';

import 'components/LicenseTable/licenseTable.scss';

import { FormattedMessage, useIntl } from 'react-intl';

interface LicenseTableProps<T> {
	data: { id: number; text: string; }[];
	header: string;
	itemType: string;
	label?: string;
	setSelectedData: Dispatch<SetStateAction<{ id: number; text: string; }[]>>;
}

export function LicenseTable<T>({
    data: data,
    header: header,
    itemType: itemType,
    label: label,
    setSelectedData: setSelectedData
}: LicenseTableProps<T>) {

    const { formatMessage } = useIntl();

    const [productComponents, setProductComponents] = useState([{ id: 0, text: formatMessage({ id: 'select_a_itemtype.2d4d1962', defaultMessage: 'Select a {itemType}' }, { itemType }) }]);

    const addLicenseItem = () => {

        setProductComponents([...productComponents, { id: productComponents.length + 1, text: formatMessage({ id: 'select_a_itemtype.2d4d1962', defaultMessage: 'Select a {itemType}' }, { itemType }) }]);

    };

    const setValue = (value: { id: number; text: string; }, index: number) => {

        const newList = [...productComponents];
        productComponents.map((item, i) => {

            if (i === index) {

                newList[index] = value;

            }

        });
        setProductComponents([...newList]);
        setSelectedData([...newList]);

    };

    const removeProductItem = (i: number) => {

        const newList = [...productComponents];
        productComponents.map((item, index) => {

            if (index === i) {

                newList.splice(index, 1);

            }

        });
        setProductComponents([...newList]);
        setSelectedData([...newList]);

    };

    useEffect(() => {

        setProductComponents([{ id: 0, text: `Select a ${itemType}` }]);

    }, [itemType]);

    return (
        <>
            <Container>
                {label ? (
                    <div>
                        {label}
                    </div>
                ) : (
                    <div>
&nbsp;
                    </div>
                )}
                <Card>
                    <Card.Header as="h5">
                        {header}
                    </Card.Header>
                    <Card.Body>
                        <>
                            {productComponents.map((item, i) => (
                                <>
                                    <div className={`${i > 0 ? 'border-top border-dark mt-2' : ''}`}></div>
                                    <Col>
                                        {i > 0 ? (
                                            <GMetrixButton
                                                className="m-1"
                                                onClick={() => removeProductItem(i)}
                                                tabIndex={0}
                                                variant="danger"
                                            >
                                                <FormattedMessage defaultMessage="Remove" id="remove.d34ac1e7" />
                                            </GMetrixButton>

                                        ) : null}
                                        <GMetrixDropdown
                                            className="mt-4 mb-2"
                                            dataItems={data}
                                            onChange={dataItem => setValue(dataItem, i)}
                                            value={item}
                                        />
                                    </Col>
                                </>
                            ))}
                        </>
                        <GMetrixButton
                            onClick={() => {

                                addLicenseItem();

                            }}
                            className="float-right mt-2"
                            variant="outline-primary"
                        >
                            <i className="fa-solid fa-plus" title={formatMessage({ id: 'add_another_productcoursebook.9c9897d8', defaultMessage: 'Add another product/course/book' })}></i>
                        </GMetrixButton>
                    </Card.Body>
                </Card>
            </Container>
        </>
    );

}
